/**
 * 404 — HeyMotek-branded "we lost this page".
 *
 * Single CTA: "Back to dashboard" → navigate('/'). ProtectedRoute handles
 * the unauthenticated case (bounces to /signin). RequireClient handles
 * mid-onboarding users (routes to their current step) and finished users
 * (renders dashboard).
 */

import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bg-tint p-4 text-center">
      <span className="font-extrabold text-3xl tracking-tight mb-8">
        <span
          style={{
            WebkitTextStroke: '2px #0F172A',
            color: 'white',
            paintOrder: 'stroke fill',
          }}
        >
          hey
        </span>
        <span className="text-brand">motek</span>
      </span>
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-dark">
        Hey, we lost this page
      </h1>
      <p className="mt-3 text-base sm:text-lg text-muted-foreground max-w-md">
        The link you followed doesn't exist (or doesn't exist yet). Head back and we'll route you to where you need to be.
      </p>
      <Button
        type="button"
        onClick={() => navigate('/')}
        className="mt-8 rounded-full bg-brand text-white hover:bg-brand-dark px-6 py-3.5 text-base font-bold"
      >
        Back to dashboard
      </Button>
    </div>
  );
}
